/**
 * ContractConfirmDialog.jsx
 *
 * @Author: wangyinan
 * @Date: 2017-10-20
 */
import './style.module.scss';
import React, { PureComponent, Fragment } from 'react';
import { Modal, Radio, Button } from 'neatui';
import ajax from 'Util/ajax';

const CONTRACT_ACTION = '/mcn/member/confirm.do';
const MCN_BIND_DEL_ACCEPT_ACTION = '/mcn/member/bindDel/accept.do';
const MCN_BIND_DEL_REFUSE_ACTION = '/mcn/member/bindDel/refuse.do';

const isEmpty = value => [undefined, null, ""].includes(value);

export default class ContractConfirmDialog extends PureComponent {
  static defaultProps = {
    isPreview: true,
    formData: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isChecked: false,
    };
  }

  onAgree = () => {
    const { formData } = this.props;
    const { applyFrom } = formData;
    return ajax(
      isEmpty(applyFrom) ? CONTRACT_ACTION : MCN_BIND_DEL_ACCEPT_ACTION,
      {
        method: 'post',
        data: {
          contractId: formData.contractId,
          operation: 1,
        },
      },
      rs => {
        this.close();
      },
    );
  };

  onReject = () => {
    const { formData } = this.props;
    const { applyFrom } = formData;
    return ajax(
      isEmpty(applyFrom) ? CONTRACT_ACTION : MCN_BIND_DEL_REFUSE_ACTION,
      {
        method: 'post',
        data: {
          contractId: formData.contractId,
          operation: 0,
        },
      },
      rs => {
        this.close();
      },
    );
  };

  open = () => {
    this.setState({
      isOpen: true,
    });
  };

  close = () => {
    this.setState({
      isOpen: false,
      isChecked: false,
    });
  };

  onCheck = e => {
    this.setState({
      isChecked: e.target.checked,
    });
  };

  render() {
    const { isPreview, trigger, formData } = this.props;
    const { isOpen, isChecked } = this.state;
    const newTrigger = React.cloneElement(trigger, {
      onClick: this.open,
    });

    const { applyTname, applyFrom } = formData;

    return (
      <span>
        {newTrigger}
        <Modal
          title={isEmpty(applyFrom) ? '签约内容' : '解绑授权'}
          styleName="invitation-dialog"
          onClose={this.close}
          isOpen={isOpen}>
          <div>
            <div styleName="contract-text">
              {+applyFrom === 1 ? <Fragment>
                <p>{applyTname}帐号申请与您解除绑定关系，<strong>同意后母帐号将即刻无法再对该子帐号行使已开通的矩阵功能。</strong></p>
                <p>如您的提现权限为母帐号统一提现，<strong>则您的提现权限将于解除绑定之日起的下一个收益计算周期（收益计算周期为上一自然月26日至本自然月25日）开始解除绑定。</strong></p>
                <p>您和子帐号之间自行约定具体的解绑规则、决定是否同意解绑，网易号平台不参与您与您的子帐号间就解绑的任何约定和沟通。</p>
              </Fragment> : null}
              {+applyFrom === 0 ? <Fragment>
                <p>{applyTname}帐号申请与您解除绑定关系，<strong>同意后母帐号将即刻无法再对您行使母帐号已开通的矩阵功能。</strong></p>
                <p>如母帐号的提现权限为母帐号统一提现，<strong>则母帐号的提现权限将于解除绑定之日起的下一个收益计算周期（收益计算周期为上一自然月26日至本自然月25日）开始解除绑定。</strong></p>
                <p>您和母帐号之间自行约定具体的解绑规则、决定是否同意解绑，网易号平台不参与您与您的母帐号间就解绑的任何约定和沟通。</p>
              </Fragment> : null}
              {isEmpty(applyFrom) ? (
                <Fragment>
                  {+formData.childDrawFlag === 0 || formData.childDrawFlag === undefined ? (
                    <Fragment>
                      <p>
                        如果您同意接受{formData.mainTname}邀请成为其矩阵功能子帐号，绑定
                        {formData.mainTname}母帐号，则{formData.mainTname}{' '}
                        母帐号（以下称“母帐号”）将有权对您在网易号平台上传的内容及您的帐号进行内容管理、成员管理、收益管理、数据分析。请您确认是否接受邀请并授权绑定。如您点击同意：
                      </p>
                      <p>
                        <strong>
                          1、自您绑定之日起下一个收益计算周期（收益计算周期的定义见《网易号运营指导手册》，以下同）开始，您帐号的全部收益金额将归属于母帐号，您可看到收益金额情况但不能提取收益金额。若您的帐号欲解除绑定，您帐号当个收益计算周期收益金额仍然归属母帐号，在您解除绑定之日起的下一个收益计算周期开始，您的帐号收益金额方重新归属您的帐号；
                        </strong>
                      </p>
                      <p>
                        2、您的帐号绑定母帐号之日起，
                        <u>
                          母帐号有权删除、下线、恢复您的帐号发布的内容以及在网易新闻客户端内推送您的帐号以及您帐号发布的内容；
                        </u>
                      </p>
                      <p>
                        3、您的帐号绑定母帐号之日起，
                        <u>
                          母帐号将有权查看您的帐号内容与帐号运营数据，包括但不限于阅读量、播放量、评论数及粉丝数等相关数据；
                        </u>
                      </p>
                      <p>
                        4、解除您和母帐号之间的绑定关系，
                        <u>
                          需要您和母帐号双方确认同意。应由您和母帐号之间自行约定具体的解绑规则、决定是否同意解绑，网易号平台不参与您与您的母帐号间就解绑的任何约定和沟通。
                        </u>
                      </p>
                      <p>
                        5、网易号不参与您与母帐号之间的具体合作关系，
                        <u>
                          如您与母帐号之间就内容的管理、删除、下线、查询数据、收益提取及分配、解绑等操作产生任何纠纷，与网易号平台无关，网易号平台对此不承担任何责任。
                        </u>
                      </p>
                    </Fragment>
                  ) : null}
                  {+formData.childDrawFlag === 1 ? (
                    <Fragment>
                      <p>
                        如果您同意接受{formData.mainTname}邀请成为其矩阵功能子帐号，绑定
                        {formData.mainTname}母帐号，则{formData.mainTname}
                        母帐号（以下称“母帐号”）将有权对您在网易号平台上传的内容及您的帐号进行内容管理、成员管理、收益管理、数据分析。请您确认是否接受邀请并授权绑定。如您点击同意：
                      </p>
                      <p>
                        <strong>
                          1、自您绑定之日起下一个收益计算周期（收益计算周期的定义见《网易号运营指导手册》）开始，母帐号将可看到您帐号的收益金额情况但不能提取收益金额；
                        </strong>
                      </p>
                      <p>
                        2、您的帐号绑定母帐号之日起，
                        <u>
                          母帐号有权删除、下线、恢复您的帐号发布的内容以及在网易新闻客户端内推送您的帐号以及您帐号发布的内容；
                        </u>
                      </p>
                      <p>
                        3、您的帐号绑定母帐号之日起，
                        <u>
                          母帐号将有权查看您的帐号内容与帐号运营数据，包括但不限于阅读量、播放量、评论数及粉丝数等相关数据；
                        </u>
                      </p>
                      <p>
                        4、解除您和母帐号之间的绑定关系，
                        <u>
                          需要您和母帐号双方确认同意。应由您和母帐号之间自行约定具体的解绑规则、决定是否同意解绑，网易号平台不参与您与您的母帐号间就解绑的任何约定和沟通。
                        </u>
                      </p>
                      <p>
                        5、网易号不参与您与母帐号之间的具体合作关系，
                        <u>
                          如您与母帐号之间就内容的管理、删除、下线、查询数据、收益提取及分配、解绑等操作产生任何纠纷，与网易号平台无关，网易号平台对此不承担任何责任。
                        </u>
                      </p>
                    </Fragment>
                  ) : null}
                </Fragment>
              ) : null}

              {/* {formData.childDrawFlag === undefined ? <Fragment>
                <p>
                  如果您同意加入MCN赋能计划，绑定{formData.mainTname}MCN机构帐号， 则{formData.mainTname}
                  MCN机构帐号将有权对您在网易号上传的内容及您的帐号进行内容管理、成员管理、收益管理、数据分析。请您确认是否加入。如您点击同意：
                </p>
                <p>
                  1、自您绑定之日起下一个收益计算周期开始，您帐号的全部收益金额将归属于MCN机构帐号，您可看到收益金额情况但不能提取收益金额。若您的帐号欲解除绑定，您帐号当个收益计算周期收益金额仍然归属原MCN机构帐号，在您解除绑定之日起的下一个收益计算周期开始，您的帐号收益金额方重新归属您的帐号；
                </p>
                <p>2、您的帐号绑定MCN机构帐号之日起，MCN机构帐号有权下线及恢复您的帐号发布的内容；</p>
                <p>3、您的帐号绑定MCN机构帐号之日起，MCN机构帐号将有权查看您的帐号内容与帐号运营数据；</p>
                <p>
                  4、您的帐号绑定MCN机构帐号之日起，MCN机构帐号将有权在网易新闻客户端内推送您的帐号发布的内容。网易号不参与您与
                  {formData.mainTname}MCN机构帐号之间的具体合作关系，如您与{formData.mainTname}
                  MCN机构帐号之间产生争议或纠纷，与网易号无关，网易号对此不承担任何责任。
                </p>
              </Fragment> : null} */}
            </div>
            {isPreview ? null : (
              <div>
                <Radio
                  styleName="check-contract"
                  onChange={this.onCheck}
                  label="我已阅读并同意以上内容"
                />
                <div styleName="form-actions">
                  <Button
                    disabled={!isChecked}
                    size="small"
                    className="tool-tip-btn"
                    type="primary"
                    onClick={this.onAgree}>
                    同意
                  </Button>
                  <Button
                    disabled={!isChecked}
                    size="small"
                    className="tool-tip-btn cancel"
                    onClick={this.onReject}>
                    拒绝
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </span>
    );
  }
}
